import { useAppSelector } from '@frontend/common';
import { EquipmentConstraintData, isEquipmentConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { EquipmentConstraintDataInputProps } from './equipment-constraint-data-input.component';

interface ViewProps {
    formValues: EquipmentConstraintData;
}

const useEquipmentConstraintDataInput = (props: EquipmentConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isEquipmentConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { equipment_id: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useEquipmentConstraintDataInput;
